<template>
  <div id="userLayout" :class="['user-layout-wrapper', device]">
    <div class="container" :style="{height:screenHeight+'px'}">
      <div class="top">
        <div class="header">
          <div class="logo">
            <img src="/logo.png" alt="logo">
          </div>
          <div class="title">
            Relaxcert {{ $t('main.title') }}
          </div>
          <div class="extra">
            <a href="https://doc.relaxcert.com" target="_blank">{{ $t('user.document') }}</a>
          </div>
        </div>

      </div>
      <div>
        <route-view></route-view>
      </div>

      <div class="footer" v-if="getI18nLanguage()==='zh-CN'">
        <div class="copyright">
          <span style="color: rgb(168,250,255);margin-right: 20px;">@copyright 2024 慧享软件</span>
          <a href="https://beian.miit.gov.cn" class="copyright-link">桂ICP备2024043074号</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteView from './RouteView'
import { mixinDevice } from '@/utils/mixin'
import { getI18nLanguage } from '@/locales'

export default {
  name: 'UserLayout',
  methods: { getI18nLanguage },
  components: { RouteView },
  mixins: [mixinDevice],
  data () {
    return {
      screenHeight: 0
    }
  },
  created () {
    this.screenHeight = document.body.clientHeight
  },
  mounted () {
    document.body.classList.add('userLayout')
  },
  beforeDestroy () {
    document.body.classList.remove('userLayout')
  }
}
</script>

<style lang="less" scoped>

.copyright-link{
  color:#ccc;
}

.copyright-link:hover{
  color:#008df6;
}
  #userLayout.user-layout-wrapper {
    height: 100%;

    &.mobile {
      .container {
        .main {
          max-width: 368px;
          width: 98%;
        }
      }
    }

    .container {
      width: 100%;
      background:url(../assets/login-bg.jpg) no-repeat;
      background-size: cover;
      padding: 110px 0 144px;
      position: relative;

      a {
        text-decoration: none;
      }

      .top {
        color:white;
        position: absolute;
        top:0;
        height: 48px;
        width: 100%;
        padding: 0 8px;
        background-color: rgba(0,0,0,.5);

        .header {
          height: 44px;
          line-height: 44px;
          display: flex;

          .badge {
            position: absolute;
            display: inline-block;
            line-height: 1;
            vertical-align: middle;
            margin-left: -12px;
            margin-top: -10px;
            opacity: 0.8;
          }

          .logo {
            height: 44px;
            vertical-align: top;
            margin-right: 8px;
            border-style: none;
            color:white;

            img{
              width: 44px;
              height: 44px;
            }
          }

          .title {
            font-size: 18px;
            font-family: Avenir, 'Helvetica Neue', Arial, Helvetica, sans-serif;
            position: relative;
            top: 2px;
            color:white;
            flex:1;
          }
        }
        .desc {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.45);
          margin-top: 12px;
          margin-bottom: 40px;
        }
      }

      .main {
        min-width: 260px;
        width: 368px;
        margin: 0 auto;
      }

      .footer {
        position: absolute;
        width: 100%;
        bottom: 0;
        padding: 0 16px;
        margin: 48px 0 24px;
        text-align: center;

        .links {
          margin-bottom: 8px;
          font-size: 14px;
          a {
            color: rgba(0, 0, 0, 0.45);
            transition: all 0.3s;
            &:not(:last-child) {
              margin-right: 40px;
            }
          }
        }
        .copyright {
          color: rgba(0, 0, 0, 0.45);
          font-size: 14px;
        }
      }
    }
  }
</style>
